// extracted by mini-css-extract-plugin
module.exports = {"container":"FAQ_container__psnxc","wrapper":"FAQ_wrapper__e11cT","viewAll":"FAQ_viewAll__M8U3E"};